import comp from "./Exemplar";
export default comp;
